import { render, staticRenderFns } from "./Statsionar.vue?vue&type=template&id=ca4461d8"
import script from "./Statsionar.vue?vue&type=script&lang=js"
export * from "./Statsionar.vue?vue&type=script&lang=js"
import style0 from "./Statsionar.vue?vue&type=style&index=0&id=ca4461d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports